import { useGetCountries } from 'api/countries/use-get-countries.ts';
import type { CountryRes } from 'api/swagger';

export const useFindCountry = (countryId?: number): CountryRes | undefined => {
  const { data } = useGetCountries();

  if (countryId && data) {
    return data.find((country) => country.id === countryId);
  }
};
